var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconBomb = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { strokeLinejoin: "round", d: "M1.8,18.9c0-1.4,0.3-2.8,1-4.1c1.6-3.1,4.7-5.1,8.2-5.1c1.4,0,2.8,0.3,4.1,1\n\t\tc0,0,2.8-2.4,2.9-2.4c0,0,3.4,4.6,3.4,4.6c0,0-2.1,1.9-2.1,1.9c0.6,1.3,1,2.7,1,4.1c0,3.5-2,6.7-5.1,8.2c-1.3,0.6-2.7,1-4.1,1h-0.5\n\t\tc-4.7-0.3-8.4-4-8.7-8.7V18.9L1.8,18.9z" }),
                React.createElement("g", { transform: "translate(59.358 -145.928) rotate(50)" },
                    React.createElement("line", { x1: "99.5", y1: "127.9", x2: "97.5", y2: "127.9" }),
                    React.createElement("line", { x1: "89.5", y1: "123.3", x2: "90.9", y2: "124.7" }),
                    React.createElement("line", { x1: "94", y1: "124", x2: "94", y2: "122" }),
                    React.createElement("line", { x1: "90.5", y1: "127.9", x2: "88.5", y2: "127.9" }),
                    React.createElement("line", { x1: "98.5", y1: "123.3", x2: "97.1", y2: "124.7" })),
                React.createElement("line", { x1: "21.3", y1: "9.2", x2: "19.8", y2: "10.5" }),
                React.createElement("path", { d: "M5.8,18.5c0.4-1.1,1-2.1,1.7-3c0.7-0.7,1.5-1.3,2.5-1.6" })))));
});
export default IconBomb;
//# sourceMappingURL=IconBomb.js.map